import vox from "../img/others/vox.png";
import aditivo from "../img/others/adtv.svg";

export const projects = [
  {
    slug: "gestao-plantao",
    nameProject: "Gestão de Plantão",
    tag: "TCC · FLUIG · TWILIO · DESTAQUE",
    thumbLabel: "GESTÃO_DE_PLANTÃO.FLUIG",
    description:
      "Sistema corporativo desenvolvido para automatizar o gerenciamento de plantões da Nova Rota do Oeste. Integrado ao Fluig e à API da Twilio, o sistema realiza comunicações via WhatsApp e voz, com foco em eficiência operacional, escalabilidade e integração com processos internos.",
    fullDescription: [
      "O sistema de Gestão de Plantão foi desenvolvido como Trabalho de Conclusão de Curso e implementado em ambiente corporativo na Nova Rota do Oeste. O objetivo principal foi eliminar processos manuais de convocação e controle de plantões, que antes dependiam de ligações telefônicas e registros em papel.",
      "A integração com a API da Twilio permitiu automatizar o envio de notificações via WhatsApp e ligações de voz, garantindo que os colaboradores recebessem as convocações de forma rápida e confiável. O sistema também se conecta ao ERP TOTVS RM para sincronizar dados de colaboradores e setores.",
      "O Fluig foi utilizado como plataforma de workflow, controlando o fluxo de aprovações e registros das escalas. Todo o back-end foi desenvolvido em PHP, com banco de dados SQL Server, e a interface construída com HTML, CSS e jQuery seguindo as diretrizes de design do portal corporativo.",
    ],
    highlights: [
      "Integração com API Twilio para notificações WhatsApp e voz",
      "Conexão com ERP TOTVS RM via API REST",
      "Fluxo de aprovação automatizado no Fluig",
      "Redução de processos manuais de convocação",
      "Interface responsiva integrada ao portal corporativo",
    ],
    image: vox,
    technologies: [
      "php",
      "jquery",
      "twilio",
      "sqlserver",
      "rm",
      "fluig",
      "figma",
    ],
    stamp: "tcc",
    link: null,
    githubLink: null,
  },
  {
    slug: "aditivo-encerramento",
    nameProject: "Aditivo, encerramento, carta e notificação",
    tag: "FLUIG · TOTVS RM · BPMN",
    thumbLabel: "ADITIVO_ENCERRAMENTO.FLUIG",
    description:
      "Processo desenvolvido no Fluig para o setor de Suprimentos da Nova Rota do Oeste, com o objetivo de formalizar aditivos, encerramentos contratuais e comunicações oficiais com fornecedores. O fluxo garante padronização, rastreabilidade e conformidade nas aprovações e emissões de documentos.",
    fullDescription: [
      "Este processo foi desenvolvido no Fluig para atender uma demanda crítica do setor de Suprimentos: formalizar de maneira padronizada os aditivos contratuais, encerramentos e comunicações com fornecedores, que antes eram gerados manualmente em Word sem rastreabilidade.",
      "O fluxo BPMN desenvolvido guia o usuário por todas as etapas necessárias, desde o preenchimento das informações do contrato até a aprovação final pelos gestores responsáveis. Após a aprovação, o sistema gera automaticamente os documentos formatados conforme o padrão da empresa.",
      "A integração com o ERP TOTVS RM permite buscar automaticamente dados de contratos e fornecedores, eliminando a necessidade de digitação manual e reduzindo erros. O processo garante que toda documentação fique armazenada e rastreável no ECM do Fluig.",
    ],
    highlights: [
      "Fluxo BPMN com múltiplas etapas de aprovação",
      "Geração automática de documentos padronizados",
      "Integração com TOTVS RM para dados de contratos",
      "Armazenamento e rastreabilidade no ECM do Fluig",
      "Redução de erros e retrabalho no setor de Suprimentos",
    ],
    image: aditivo,
    technologies: ["html", "css", "jquery", "fluig", "rm"],
    stamp: "fluig",
    link: null,
    githubLink: null,
  },
  {
    slug: "desafio-livraria",
    nameProject: "API Rest Para Gerenciamento de Livraria",
    tag: "TYPESCRIPT · FASTIFY · PRISMA",
    thumbLabel: "PROJETO_LIVRARIA.API",
    description:
      "API REST desenvolvida em TypeScript para gerenciamento de livraria, com autenticação JWT, CRUD completo de livros, autores e editoras, e persistência em MongoDB via Prisma.",
    fullDescription: [
      "O projeto foi desenvolvido como desafio da pós-graduação em Full-Stack Development da FIAP, com foco em construir uma API moderna e tipada para gerenciamento de biblioteca.",
      "A aplicação utiliza Fastify no back-end e organiza a lógica em camadas de rotas, controllers e services, mantendo o código modular e fácil de evoluir.",
      "O sistema conta com autenticação de usuários (registro e login), proteção de rotas de escrita com token JWT e recursos de auditoria (`createdBy` e `editedBy`) para rastrear alterações.",
      "A persistência de dados é feita com Prisma ORM conectado ao MongoDB, incluindo relacionamentos entre livros, autores e editoras.",
    ],
    highlights: [
      "CRUD completo de livros, autores e editoras",
      "Autenticação com JWT e senhas com hash via bcryptjs",
      "Rotas de escrita protegidas por middleware de autenticação",
      "Relacionamentos entre entidades com Prisma",
      "Campos de auditoria para criação e edição de registros",
    ],
    image: null,
    technologies: [
      "typescript",
      "nodejs",
      "fastify",
      "prisma",
      "mongodb",
      "jwt",
      "bcryptjs",
    ],
    stamp: "fiap",
    link: null,
    githubLink: "https://github.com/luccsll/Desafio-Livraria",
  },
];
